import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { Button, COLORS, Select, Text } from '../Basics';
import { Screen } from '../../screens/Screen';
import LorentzService from '../../services/LorentzService';

export const QualificationModal = () => {
  const [visible, setVisible] = useState(false);
  const [payload, setPayload] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const onRequired = ev => {
      const data = ev.detail || ev.data;
      setPayload(data);
      setSelectedId(null);
      setError('');
      setVisible(true);
    };

    document.addEventListener('lorentz:qualification:required', onRequired);
    return () =>
      document.removeEventListener('lorentz:qualification:required', onRequired);
  }, []);

  const qualifications =
    payload?.qualifications ||
    payload?.form?.qualifications ||
    [];

  const options = qualifications.map(q => ({
    value: String(q.id ?? q.cod ?? q.Cod),
    text: q.name ?? q.desc ?? q.Desc ?? `Qualificação ${q.id ?? q.cod}`
  }));

  const handleSubmit = async () => {
    if (!selectedId) {
      setError('Selecione uma qualificação');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      await LorentzService.submitQualification({
        callId: payload?.callId,
        qualificationId: Number(selectedId),
        phone: payload?.phone
      });
      setVisible(false);
      setPayload(null);
    } catch (err) {
      setError(err?.message || 'Erro ao qualificar');
    } finally {
      setSubmitting(false);
    }
  };

  const handleSkip = () => {
    if (payload?.mandatory) {
      setError('Qualificação obrigatória para este atendimento');
      return;
    }
    setVisible(false);
    setPayload(null);
  };

  if (!visible) return null;

  return (
    <Screen
      visible
      closeable={!payload?.mandatory}
      onClose={handleSkip}
      color="rgba(0,0,0,0.45)"
      bodyStyle={{ justifyContent: 'center', alignItems: 'center' }}
    >
      <View
        style={{
          width: '90%',
          maxWidth: 340,
          backgroundColor: COLORS.app,
          borderRadius: 8,
          padding: 16
        }}
      >
        <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8 }}>
          Qualificar atendimento
        </Text>
        {payload?.phone ? (
          <Text style={{ color: COLORS.textSecondary, marginBottom: 12 }}>
            Telefone: {payload.phone}
            {payload?.callId ? ` · Atend. ${payload.callId}` : ''}
          </Text>
        ) : null}

        {options.length > 0 ? (
          <Select
            options={options}
            value={selectedId}
            onChange={setSelectedId}
          />
        ) : (
          <Text style={{ color: COLORS.textSecondary }}>
            Nenhuma qualificação disponível na API.
          </Text>
        )}

        {error ? (
          <Text style={{ color: COLORS.danger, marginTop: 8 }}>{error}</Text>
        ) : null}

        <View style={{ flexDirection: 'row', gap: 8, marginTop: 16 }}>
          {!payload?.mandatory && (
            <Button color={COLORS.borderColor} onClick={handleSkip}>
              <Text>Pular</Text>
            </Button>
          )}
          <Button
            color="primary"
            style={{ flex: 1 }}
            onClick={handleSubmit}
          >
            <Text style={{ color: '#fff' }}>
              {submitting ? 'Salvando...' : 'Confirmar'}
            </Text>
          </Button>
        </View>
      </View>
    </Screen>
  );
};

export default QualificationModal;
